var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null),
settings = require( "../../src/js/lib/settings" );

/**
 * Initializes the site header.
 * @constructor
 * @param {Object} el - The site header element.
 */

function Header(el) {
  this.el = el;
  this.$el = $(el);

  //Main menu mobile nav trigger
  var mobileMenu = $('.nav__links-wrapper');
  $('.nav__trigger').click(function(){
	  toggleMainNav();
	  $(this).attr('aria-expanded', $(this).hasClass('is-open'));
      mobileMenu.attr('aria-expanded', $(this).hasClass('is-open'));
  });

  $('.nav__links-wrapper a').last().on('keydown', function (e) {
    if (e.key === 'Tab' && !e.originalEvent.shiftKey) {
        e.preventDefault();
        $('.nav__trigger')[0].focus();
    }
  });

  $('.nav__trigger').on('keydown', function (e) {
    if (e.key === 'Tab' && e.originalEvent.shiftKey) {
      if ($(this).hasClass('is-open')) {
        e.preventDefault();
        $('.nav__links-wrapper a').last().focus();
      }
    }
  });

  var clickOutSide = function () {
    $(document).mouseup(function(e) {
      var mainMenu = $('.nav__links-wrapper');
      if (!mainMenu.is(e.target) && mainMenu.has(e.target).length === 0)
      {
        $('.nav__links > .menu-item-has-children').removeClass('menu-item--active');
        $('.nav__links > .menu-item-has-children > button').attr('aria-expanded', false);
        var searchTrigger = $('.menu-search > a');
        let clickedElement = e.target,
            inputField = document.querySelector('.search__container-inner');

        if (searchTrigger.hasClass('is-open') && (!inputField.contains(clickedElement))) {
          $('.menu-search > a').removeClass('is-open').attr('aria-expanded', false);
          $('.search__container-inner').slideToggle();
        }
      }
    });
  }

  clickOutSide();

  var parentMenus = $('.menu-item-has-children');
  var menuControlers = $('.menu-item-has-children > a');

  $('.menu-item-has-children > a').each(function (index) {
    var menuID = Date.now() + index;
    var triggerButton = '<button class="menu-item-trigger" aria-expanded="false" aria-controls="' + menuID + '"><span class="menu-arrow-icon"></span><span class="sr-only">' + $(this).text() + ' sub menu</span></button>';
    var triggerButtonSubmenu = '<button class="menu-item-trigger" aria-expanded="false" aria-controls="' + menuID + '"><span class="sub-menu-arrow-icon"></span><span class="sr-only">' + $(this).text() + ' sub menu</span></button>';
    $(this).next().attr('id', menuID);
    if (!$(this).parent().parent().hasClass('sub-menu')) {
        $(this).after(triggerButton);
    } else {
        $(this).after(triggerButtonSubmenu);
    }
  });

  var toggleMainNav = function() {
	  if ($(window).outerWidth() < settings.breakpoints.header) {
      //$('.nav__links-wrapper').slideToggle();
	  toggleSearchbox('close');

	  $('body').toggleClass('nav-opening');

      $('.nav__links-wrapper, .nav__trigger, .header__inner').toggleClass('is-open');

      //change text on click
      var el = $('.nav__trigger-text');
      if (el.text() == el.data("text-toggle")) {
        el.text(el.data("text-original"));
      } else {
        el.data("text-original", el.text());
        el.text(el.data("text-toggle"));
      }
    }
  };

  //On resize, show links wrapper, remove display none, close menus
  var $menu = $('.nav__links-wrapper');
  var $openlinks = $('.nav__primary > .menu-item-has-children, .sub-menu--level-0 > .menu-item-has-children');

  $(window).on("resize", function () {
    var headerHeight = 0;
    if ($(window).outerWidth() >= settings.breakpoints.header /*&& !menu.is(':visible')*/ ) {
      $menu.css({'display':''});
      $menu.removeClass('is-open');
      $openlinks.removeClass('is-open');
      $('.header__inner').removeClass('is-open');
    }
  }).resize();

  //Mobile Dropdowns
  /*First Level*/
  $('.menu-item-has-children > button').each(function(e){
   if ($(window).outerWidth() < settings.breakpoints.header) {
       var parentEl = $(this).parent();
       $(this).on('click', function () {
           $('.sub-menu--level-0', parentEl).slideToggle();
           $(parentEl).toggleClass('is-open');
       });

       $('.sub-menu--level-0 a', parentEl).last().on('keydown', function (e) {
           if (e.key === 'Tab' && !e.originalEvent.shiftKey) {
               $('.sub-menu--level-0', parentEl).slideToggle();
               $(parentEl).toggleClass('is-open');
           }
       });
    }
  });

  var toggleSubmenu = function (parentEl) {
        $('.sub-menu--level-1', parentEl).slideToggle();
        $(parentEl).toggleClass('is-open');
        if (parentEl.hasClass('pre-selected')) {
            parentEl.removeClass('pre-selected is-open');
        }
      };

  //Second Level
  var $secondLevelLinks = this.$el.find('.sub-menu--level-1 .menu-item-has-children a');
  var $secondLevelTrigger = this.$el.find('.sub-menu--level-0 > .menu-item-has-children > button');
  $secondLevelTrigger.each(function() {
    var parentEl = $(this).parents('.sub-menu--level-0 > .menu-item-has-children');
    var controller = $(this);

    $(this).on('click', function() {
        toggleSubmenu(parentEl);
    });

    var submenuLinks = $('.sub-menu--level-1 a', parentEl);

    submenuLinks.last().on('keydown', function (e) {
        if (e.key === 'Tab' && !e.originalEvent.shiftKey) {
            toggleSubmenu(parentEl);
            controller.attr('aria-expanded', false);
        }
    });
  });

  //Search Container
  var searchTrigger = $('.nav__mobile-search, .menu-search a'),
  searchBox = $('.search__container-inner');
  searchTrigger.attr('aria-expanded', false);
  searchTrigger.attr('aria-controls', 'search-content');

  // Hide Mobile Nav and Subnav on load
  $(searchBox).hide();

  $(searchTrigger).click(function(e) {
	  e.preventDefault();
      enableSearchBox();
  });

  var enableSearchBox = function () {
      if($('.nav__trigger').hasClass('is-open')) {
          toggleMainNav();
      }

      $(searchTrigger).attr("aria-expanded", searchTrigger.hasClass('is-open'));
      toggleSearchbox(searchTrigger);
  };

  var toggleSearchbox = function(action) {
	  var $li = $(action.currentTarget),
      $searchBox = $('.search__container-inner'),
      $navMenu = $('.nav__links-wrapper');

      $('.search__container-inner').slideUp();
      $li.removeClass('is-open');
      $('.menu-search a').removeClass('selected');
      $navMenu.removeClass('is-faded');

      if ($searchBox.is(':hidden') && action !== 'close') {
          $('#search__container').addClass('is-open');
          $searchBox.slideDown();
          $li.addClass('is-open');
          $li.find('a').addClass('selected');
          $navMenu.addClass('is-faded');
          $('#search__container .search__input').focus();
      } else {
          $('#search__container').removeClass('is-open');
          $searchBox.slideUp();
          $li.find('a').removeClass('selected');
          $navMenu.removeClass('is-faded');
      }
  };

  $('.search__container-inner button').on('keydown', function (e) {
      if (e.key === 'Tab' && !e.originalEvent.shiftKey) {
          e.preventDefault();
          searchTrigger.focus();
      }
  });

  $(searchTrigger).on('keydown', function (e) {
      if (e.key === 'Tab' && !e.originalEvent.shiftKey && $('#search__container').hasClass('is-open')) {
        e.preventDefault();
        $('#search__container .search__input').focus();
      }

      if (e.key === 'Tab' && e.originalEvent.shiftKey && $('#search__container').hasClass('is-open')) {
        e.preventDefault();
        $('.search__container-inner button').focus();
      }
  });

  //Change border color of parent container when input is clicked

  $(".search__input").focus(function(){
        $(this).parent().addClass('is-active');
  });

  //Show submenu when focus to parents link
  var  navItemLinks = $(".menu-item-has-children > button", el);
  var  navItemParents = $(".menu-item-has-children", el);

  if (navItemParents) {
    navItemLinks.each(function () {
      var controller = $(this);
      var submenuLinks = $('.sub-menu a', $(this).parent());
      var parentLink = $(this).parent();

      controller.on('click', function () {
          if ($(this).parent().hasClass('menu-item--active')) {
              $(this).parent().removeClass('menu-item--active');
              $(this).attr('aria-expanded', false);
          } else {
              $(this).parent().addClass('menu-item--active');
              $(this).attr('aria-expanded', true);
          }
      });

      submenuLinks.last().on('keydown', function (e) {
        if (e.key === 'Tab' && !e.originalEvent.shiftKey) {
          parentLink.removeClass('menu-item--active');
          controller.attr('aria-expanded', false);
        }
      });
    });
  }

  var topLevelLinks = this.$el.find('.nav__links > .menu-item > button');
  if (topLevelLinks.length) {
    topLevelLinks.on('click', function(e) {
        var parentEl = $(this).parent();
        var parentSiblings = parentEl.siblings('.menu-item--active');

        if (parentSiblings.length) {
            parentSiblings.removeClass('menu-item--active');
        }
    });
  }

  // If the focus state is targeting skip links, hide all active header dropdown menus
  var topLevelMenuItems = this.$el.find('.nav__links > .menu-item');
  $('.skip-link').on('focus', function () {
      if (topLevelMenuItems.hasClass('menu-item--active')) {
          topLevelMenuItems.removeClass('menu-item--active');
      }
  });
}

module.exports = Header;
